import { Button, Card, Message, Tabs } from "@arco-design/web-react"
import { CompanyInfo } from "./company-info";
import { ContactInfo } from "./contact-info";
import { Users } from "./users";
import { EmailTemplates } from "./email-templates";
import { useEffect, useState } from "react";
import { CompanyAPI } from "@/apis/system";

const TabPane = Tabs.TabPane;

export const CompanyProfile = () => {
    const [companyInfo, setCompanyInfo] = useState();
    const [updatedCompanyInfo, setUpdatedCompanyInfo] = useState();

    useEffect(() => {
        const getCompanyInfo = async () => {
            const values = await CompanyAPI.info();
            setCompanyInfo(values);
        }
        getCompanyInfo();
    }, [])

    const handleSave = async () => {
        try {
            await CompanyAPI.update(updatedCompanyInfo);
            Message.success('Updated Successfully');
            setCompanyInfo(updatedCompanyInfo);
        } catch (error) {
            Message.error('Failed to update', error);
        }
    };

    return (
        <Card title="Company Profile" extra={
            <Button type="primary" onClick={handleSave}>Save</Button>
        }>
            <Tabs defaultActiveTab="company">
                <TabPane key="company" title="Company Info">
                    <CompanyInfo value={companyInfo} onChange={(values) => {
                        setUpdatedCompanyInfo(values);
                    }} />
                </TabPane>
                <TabPane key="contact" title="Contact Info">
                    <ContactInfo value={companyInfo} onChange={(values) => setUpdatedCompanyInfo(values)} />
                </TabPane>
                <TabPane key="users" title="Users">
                    <Users />
                </TabPane>
                <TabPane key="email" title="Email Templates">
                    <EmailTemplates value={companyInfo} onChange={(values) => setUpdatedCompanyInfo(values)} />
                </TabPane>
            </Tabs>
        </Card>
    )
}